import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setSection, updateSection } from "../../../assignmentSlice";
import { getGradeAPI } from "../../../assignmentAPI";
import { getStartingIndex } from "../../../../../utils/resumeUtils";

import UserInputBar from "../../widgets/UserInputBar";
import CommonPage from "../../common/CommonPage";

const CompositionPage = ({ setCurrentStep, isPreview, isReview }) => {
  const dispatch = useDispatch();
  const { section } = useSelector((state) => state.assignment);

  const [pageList, setPageList] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [userInput, setUserInput] = useState("");
  const [overlayVisible, setOverlayVisible] = useState(false);
  const [isCorrect, setIsCorrect] = useState(false);

  const currentPage = pageList[currentIndex] || {
    question: "",
    answer: "",
  };

  useEffect(() => {
    if (pageList.length > 0) return;

    if (!isPreview && section.answer.length > 0) {
      setPageList(section.answer);
      setCurrentIndex(getStartingIndex(section.resumeIndex));
      return;
    }
    setPageList(
      section.question.data.map((question) => {
        return { ...question, input: "", isSubmitted: false, isCorrect: false };
      })
    );
    setCurrentIndex(0);
  }, [section]);

  useEffect(() => {
    if (currentPage.isSubmitted) {
      if (currentPage.isCorrect) {
        setUserInput(currentPage.input);
      } else {
        setUserInput(currentPage.answer);
      }
    } else {
      setUserInput(currentPage.input || "");
    }
  }, [currentIndex]);

  const handleChange = (e) => {
    setUserInput(e.target.value);
    if (currentPage.isSubmitted) {
      const newPageList = pageList.map((page, pageIndex) => {
        if (pageIndex === currentIndex) {
          return {
            ...page,
          };
        }
        return page;
      });
      setPageList(newPageList);
      dispatch(setSection({ ...section, answer: newPageList }));
    }
  };

  const handleSetAnswer = () => {
    const newPageList = pageList.map((page, pageIndex) => {
      if (pageIndex === currentIndex) {
        return {
          ...page,
          input: userInput,
        };
      }
      return page;
    });
    setPageList(newPageList);
    dispatch(setSection({ ...section, answer: newPageList }));
  };

  const handleNextPage = () => {
    if (currentIndex < pageList.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      let isAllAnswered = true;

      pageList.forEach((page, index) => {
        if (!page.isSubmitted) {
          isAllAnswered = false;
        }
      });

      if (isAllAnswered) {
        if (!isPreview && !isReview) {
          dispatch(
            updateSection({
              sectionId: section.id,
              data: { is_finished: true, answer: pageList },
            })
          );
        }
        alert("학습이 완료되었습니다.");
        setCurrentStep(2);
      } else {
        alert("문제를 덜 풀었습니다.");
      }
    }
  };

  const handlePreviousPage = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleSubmit = async () => {
    if (currentPage.isSubmitted) return;
    if (userInput === "") {
      return alert("답을 입력해주세요.");
    }

    const grade = await getGradeAPI({
      data: {
        kor: currentPage.question,
        input: userInput,
        answer: currentPage.answer,
      },
      type: "composition",
    });

    setOverlayVisible(true);
    setIsCorrect(grade.is_correct === 1);

    const newPageList = pageList.map((page, pageIndex) => {
      if (pageIndex === currentIndex) {
        return {
          ...page,
          input: userInput,
          isCorrect: grade.is_correct === 1,
          isSubmitted: true,
        };
      }
      return page;
    });
    setPageList(newPageList);
    dispatch(setSection({ ...section, answer: newPageList }));

    setTimeout(() => {
      setOverlayVisible(false);
      if (grade.is_correct === 0) {
        setUserInput(currentPage.answer);
      }
    }, 600);
  };

  return (
    <CommonPage
      currentIndex={currentIndex}
      handleNextPage={handleNextPage}
      handlePreviousPage={handlePreviousPage}
      totalNo={pageList.length}
      currentPage={currentPage}
      overlayVisible={overlayVisible}
      isCorrect={isCorrect}
      handleSubmit={handleSubmit}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "50px",
          width: "90%",
        }}
      >
        <div
          style={{
            fontSize: "20px",
          }}
        >
          {"주어진 한국어 문장을 영어로 작문하시오."}
        </div>
        <div
          style={{
            fontSize: "28px",
            textAlign: "center",
            lineHeight: "1.5",
          }}
        >
          {currentPage.question}
        </div>
        <div style={{ width: "80%", position: "relative" }}>
          <UserInputBar
            userInput={userInput}
            handleChange={handleChange}
            type={"sentence"}
            handleSetAnswer={handleSubmit}
            onlyUnderline={true}
            isSubmitted={currentPage.isSubmitted}
          />
        </div>
      </div>
    </CommonPage>
  );
};

export default CompositionPage;
